/**
 * API управления пользователями. Только admin.
 */
import { apiDelete, apiJson } from './client.js'

export async function getMyBillingUsage() {
  return apiJson('/admin/users/me/billing', {}, 'Failed to load billing usage')
}

export async function getMyCapabilities() {
  return apiJson('/admin/users/me/capabilities', {}, 'Failed to load access settings')
}

export async function getUsers({ limit = 20, offset = 0 } = {}) {
  const params = new URLSearchParams({ limit, offset })
  return apiJson(`/admin/users?${params}`, {}, 'Не удалось загрузить пользователей')
}

export async function createUser(payload) {
  return apiJson(
    '/admin/users',
    {
      method: 'POST',
      body: JSON.stringify({ ...(payload || {}) }),
    },
    'Не удалось создать пользователя'
  )
}

export async function getUserId(userId) {
  return apiJson(`/admin/users/${userId}`, {}, 'Не удалось загрузить пользователя')
}

export async function updateUser(userId, payload) {
  const body = {}
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value !== undefined) body[key] = value
  })
  return apiJson(
    `/admin/users/${userId}`,
    { method: 'PATCH', body: JSON.stringify(body) },
    'Не удалось обновить пользователя'
  )
}

export async function deleteUser(userId) {
  await apiDelete(`/admin/users/${userId}`, 'Не удалось удалить пользователя')
}

export async function getUserModels(userId) {
  return apiJson(`/admin/users/${userId}/models`, {}, 'Не удалось загрузить модели')
}

export async function addUserModel(userId, modelId) {
  return apiJson(
    `/admin/users/${userId}/models`,
    { method: 'POST', body: JSON.stringify({ model_id: modelId }) },
    'Не удалось добавить модель'
  )
}

export async function removeUserModel(userId, modelId) {
  await apiDelete(`/admin/users/${userId}/models/${modelId}`, 'Не удалось убрать модель')
}
